import React from "react";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import Page from "../Page";
import WorkOrdersListing from './Listing.js'

const Index = () => {
  return <Page
      uiPage={uiManager.getUiPage(PAGES.WorkOrdersListingPage.name)}
      breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Work Orders'}]}
    >
    <WorkOrdersListing/>
    </Page>
};

export default Index;
